/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clock: NonNullable<unknown>, done: NonNullable<unknown>, total: NonNullable<unknown> }} Shell_Live_Running_LabelInputs */

const en_us2_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Continue workout: ${i?.clock} in progress, ${i?.done} of 1 set`);
	return /** @type {LocalizedString} */ (`Continue workout: ${i?.clock} in progress, ${i?.done} of ${i?.total} sets`)
	
};

const pt_br2_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Continuar treino: ${i?.clock} em andamento, ${i?.done} de 1 série`);
	return /** @type {LocalizedString} */ (`Continuar treino: ${i?.clock} em andamento, ${i?.done} de ${i?.total} séries`)
	
};

const es_419_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Continuar entrenamiento: ${i?.clock} en curso, ${i?.done} de 1 serie`);
	return /** @type {LocalizedString} */ (`Continuar entrenamiento: ${i?.clock} en curso, ${i?.done} de ${i?.total} series`)
	
};

const pt_pt2_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Continuar treino: ${i?.clock} a decorrer, ${i?.done} de 1 série`);
	return /** @type {LocalizedString} */ (`Continuar treino: ${i?.clock} a decorrer, ${i?.done} de ${i?.total} séries`)
	
};

const fr_fr2_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Reprendre la séance : ${i?.clock} en cours, ${i?.done} sur 1 série`);
	return /** @type {LocalizedString} */ (`Reprendre la séance : ${i?.clock} en cours, ${i?.done} sur ${i?.total} séries`)
	
};

const de_de2_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Training fortsetzen: ${i?.clock} läuft, ${i?.done} von 1 Satz`);
	return /** @type {LocalizedString} */ (`Training fortsetzen: ${i?.clock} läuft, ${i?.done} von ${i?.total} Sätzen`)
	
};

const it_it2_shell_live_running_label = /** @type {(inputs: Shell_Live_Running_LabelInputs) => LocalizedString} */ (i) => {
	if ((i?.total === 1 || i?.total === "1")) return /** @type {LocalizedString} */ (`Continua allenamento: ${i?.clock} in corso, ${i?.done} di 1 serie`);
	return /** @type {LocalizedString} */ (`Continua allenamento: ${i?.clock} in corso, ${i?.done} di ${i?.total} serie`)
	
};

/**
* | total | output |
* | --- | --- |
* | "1" | "Continue workout: {clock} in progress, {done} of 1 set" |
* | * | "Continue workout: {clock} in progress, {done} of {total} sets" |
*
* @param {Shell_Live_Running_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_live_running_label = /** @type {((inputs: Shell_Live_Running_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Live_Running_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_live_running_label(inputs)
	if (locale === "es-419") return es_419_shell_live_running_label(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_live_running_label(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_live_running_label(inputs)
	if (locale === "de-DE") return de_de2_shell_live_running_label(inputs)
	if (locale === "it-IT") return it_it2_shell_live_running_label(inputs)
	return en_us2_shell_live_running_label(inputs)
});
export { shell_live_running_label as "shell.live_running_label" }